'use client';

import { type ReactNode, useState } from 'react';

import { CalendarBookingContext, type CalendarBookingContextValue } from '.';
import { useAvailableDates } from '../hooks/use-available-dates';

// Re-export hook + type from the context module so existing consumers
// that import from this file keep working.
export { useCalendarBookingContext } from '.';
export type { CalendarBookingContextValue } from '.';

// ─── Provider ────────────────────────────────────────────────────────────

export function CalendarBookingProvider({
  storeId,
  children,
}: {
  storeId: string | undefined;
  children: ReactNode;
}) {
  // calendarAuthorized is now returned by the available dates API itself,
  // so no separate userApiControllerGetPublicFeatures call is needed.
  const availableDates = useAvailableDates(storeId);
  const [bookingVersion, setBookingVersion] = useState(0);

  function onBooked() {
    availableDates.refresh();
    setBookingVersion(v => v + 1);
  }

  function refreshFeatures() {
    availableDates.refresh();
  }

  const value: CalendarBookingContextValue = {
    ...availableDates,
    bookingVersion,
    onBooked,
    refreshFeatures,
  };

  return (
    <CalendarBookingContext.Provider value={value}>
      {children}
    </CalendarBookingContext.Provider>
  );
}
